import type { CityConfig } from "../city-template/types";

export const castleRockConfig: CityConfig = {
  city: "Castle Rock",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "castle-rock",
  route: "/cities/castle-rock",
  title: "Emergency Passport Castle Rock, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Castle Rock, Colorado — as fast as 24 hours. Same-day courier processing for Castle Rock, Castle Pines, The Meadows, and all Douglas County travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Castle Rock, CO",
  heroSubtitle: "Family trip to Europe booked and your kid's passport hasn't arrived? Business travel to London in a week and your passport just expired? We help Castle Rock residents — from The Meadows families to downtown professionals to Douglas County commuters — get their passports as fast as 24 hours. A+ BBB rated registered courier. Just 35 miles from the Colorado Passport Agency — but you don't even need to make the drive.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Castle%20Rock%20Colorado%20scenic%20view%20with%20the%20iconic%20Castle%20Rock%20butte%20formation%20rising%20prominently%20above%20the%20town%2C%20the%20historic%20downtown%20with%20charming%20small%20town%20atmosphere%20and%20boutique%20shops%2C%20the%20Front%20Range%20Rocky%20Mountains%20as%20a%20dramatic%20backdrop%20under%20bright%20blue%20sky%2C%20the%20growing%20suburban%20community%20with%20modern%20homes%20nestled%20among%20rolling%20hills%2C%20golden%20afternoon%20sunlight%20illuminating%20the%20red%20rock%20formation%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20cinematic%20wide%20angle%20view&width=1800&height=700&seq=castle-rock-hero-001&orientation=landscape",
  heroImageAlt: "Castle Rock Colorado with iconic butte formation and Rocky Mountain backdrop",
  geoPosition: "39.3722;-104.8561",
  geoPlacename: "Castle Rock, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 35 miles north via I-25 — about 35–40 minutes",
  },
  nearbyCitiesZips: [
    { name: "Castle Rock", zips: "80104, 80108, 80109" },
    { name: "The Meadows", zips: "80109" },
    { name: "Castle Pines", zips: "80108" },
    { name: "Lone Tree", zips: "80124" },
    { name: "Highlands Ranch", zips: "80126, 80129, 80130" },
    { name: "Parker", zips: "80134, 80138" },
    { name: "Larkspur", zips: "80118" },
    { name: "Sedalia", zips: "80135" },
    { name: "Franktown", zips: "80116" },
    { name: "Monument", zips: "80132" },
    { name: "Elizabeth", zips: "80107" },
    { name: "Perry Park", zips: "80118" },
    { name: "Roxborough", zips: "80125" },
    { name: "Greenwood Village", zips: "80111, 80121" },
    { name: "Centennial", zips: "80111, 80112, 80121, 80122" },
    { name: "Littleton", zips: "80120–80130" },
    { name: "Colorado Springs", zips: "80903–80951" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier for urgent Castle Rock departures — closest Denver suburb to the agency" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — skip the I-25 commute entirely" },
    { icon: "ri-flight-takeoff-line", title: "35 Miles to the Agency", desc: "Closest major suburb south of the Colorado Passport Agency — fast courier turnaround" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in the Castle Rock area" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/cities/denver" },
    { name: "Emergency passport help in Colorado Springs", route: "/cities/colorado-springs" },
    { name: "Fast passport renewal in Highlands Ranch and Parker", route: "/cities/castle-rock" },
    { name: "Urgent passport services for Lone Tree and Castle Pines", route: "/cities/castle-rock" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services for all of Douglas County", route: "/cities/castle-rock" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Castle Rock remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Castle Rock's prime location — just 35 miles south of the Colorado Passport Agency on I-25 — means our courier service is exceptionally fast. But you don't have to deal with the drive or make an appointment.",
  fpcOfficeAddress: "370 17th St, Denver, CO 80202",
  fpcOfficeDistance: "Serving all of Douglas County and the southern I-25 corridor from Lone Tree to Monument",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Castle Rock and Douglas County. From the historic downtown around the namesake butte to The Meadows master-planned community, from Castle Pines to the residential neighborhoods along Founders Parkway — we serve every corner of Castle Rock and the surrounding south metro communities.",
  nearbyCitiesIntro: "We serve Castle Rock and all nearby communities including Castle Pines, Lone Tree, Highlands Ranch, Parker, Larkspur, Sedalia, Franktown, Monument, Elizabeth, and Roxborough. We also serve the southern Denver metro area — Centennial, Greenwood Village, and Littleton — plus northern Colorado Springs suburbs.",
  howItWorksIntro: "Most Castle Rock travelers complete everything online and ship documents overnight. At just 35 miles from the Denver agency, our courier turnaround is among the fastest in Colorado — but you never need to deal with I-25 rush hour traffic.",
  mistakesIntro: "Castle Rock is one of Colorado's fastest-growing communities with families, commuters, and professionals who travel internationally. Here are the most common passport mistakes we see from Castle Rock-area travelers.",
  testimonialsIntro: "Castle Rock travelers — from The Meadows families to downtown business owners to Douglas County professionals — trust us when departure is imminent.",
  faqIntro: "Have questions about expedited passports in Castle Rock, CO? Here are the most common ones we hear from Douglas County travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Colorado Vital Records (Birth, Death, Marriage)", href: "https://cdphe.colorado.gov/certificates-and-records" },
    { label: "Douglas County Clerk & Recorder", href: "https://www.douglas.co.us/clerk-recorder/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Drive to Denver (35 min — but I-25 traffic can double it)", "Parking fees at the agency complex"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "35 miles to Denver agency — fastest suburban courier", "No I-25 commute required", "Ideal for family vacations and business travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Castle Rock travelers with immediate departure — as fast as 24 hours. At 35 miles from the agency, our courier turnaround is among Colorado's fastest.",
      bullets: ["24–48 hour turnaround available", "Close Denver agency proximity = fastest courier route", "Family vacation and business travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Castle Rock adults with a passport issued within the last 15 years. Skip the post office and I-25 traffic.",
      bullets: ["No clerk visit required for most renewals", "Courier or mail-in options", "Returned to your Douglas County address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Castle Rock residents and Douglas County families — including kids and new citizens.",
      bullets: ["Acceptance facility scheduling in Castle Rock", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Castle Rock residents who lost their passport before international travel.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Castle Rock and Douglas County families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Castle Rock and Douglas County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Castle Rock CO", description: "Urgent passport processing for Castle Rock Colorado travelers with immediate departure needs — closest Denver suburb to the regional agency." },
    { name: "Expedited Passport Renewal Castle Rock CO", description: "Fast passport renewal for Castle Rock Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Castle Rock CO", description: "New passport application services for Castle Rock Colorado residents applying for their first passport." },
    { name: "Child Passport Castle Rock CO", description: "Minor passport services for Castle Rock Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "Stephanie M.",
      location: "Castle Rock, CO — The Meadows",
      rating: 5,
      text: "Family trip to Disneyland Paris with 8 days notice. Four passports — two renewals and two first-time for the kids. Fast Passport Center got everything done in 5 days. I shipped from the UPS Store near the Outlets and never dealt with I-25.",
      service: "Family Passport Bundle",
    },
    {
      name: "Kevin D.",
      location: "Castle Rock, CO — Downtown",
      rating: 5,
      text: "Business trip to Singapore with one week notice. Fast Passport Center processed my emergency passport in 3 days. Being so close to Denver, the courier turnaround was incredibly fast. Outstanding service.",
      service: "Emergency Passport",
    },
    {
      name: "Laura B.",
      location: "Castle Pines, CO",
      rating: 5,
      text: "Honeymoon to Italy and realized my passport was expiring in 2 months. Fast Passport Center renewed it in 4 days. The agent even caught a photo issue and helped me fix it before submission. Saved our honeymoon.",
      service: "Passport Renewal",
    },
    {
      name: "Brian W.",
      location: "Castle Rock, CO — Founders Village",
      rating: 5,
      text: "Lost my passport during a move and had a conference in Toronto in 6 days. They got me a replacement in 48 hours. As a frequent business traveler, I'll never use anyone else for passport services.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "cr-1",
      name: "Castle Rock Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "300 N Wilcox St",
      city: "Castle Rock",
      state: "CO",
      zip: "80104",
      phone: "(303) 688-5151",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Downtown Castle Rock, near the historic district",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Castle Rock acceptance facility. Appointments required — book 2–3 weeks in advance. Busiest during summer family travel season. Limited Saturday hours available.",
      icon: "ri-mail-line",
    },
    {
      id: "cr-2",
      name: "Castle Rock — The Meadows Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "804 S Perry St, Suite 100",
      city: "Castle Rock",
      state: "CO",
      zip: "80104",
      phone: "(303) 660-0572",
      hours: "Mon–Fri: 7:30 AM – 5:00 PM",
      distance: "The Meadows area, approximately 3 miles south of downtown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Extended hours — one of the earliest-opening acceptance facilities in Douglas County. Convenient for The Meadows and south Castle Rock residents.",
      icon: "ri-mail-line",
    },
    {
      id: "cr-3",
      name: "Castle Pines Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "562 Castle Pines Pkwy",
      city: "Castle Pines",
      state: "CO",
      zip: "80108",
      phone: "(303) 688-1444",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Castle Pines, approximately 5 miles north of Castle Rock",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Castle Pines and northern Douglas County. Good alternative with easier parking than downtown Castle Rock.",
      icon: "ri-mail-line",
    },
    {
      id: "cr-4",
      name: "Parker Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "18695 Pony Express Dr",
      city: "Parker",
      state: "CO",
      zip: "80134",
      phone: "(303) 841-2693",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Parker, approximately 12 miles northeast of Castle Rock",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Full-service facility with extended hours. Good for east Douglas County residents and Parker area travelers.",
      icon: "ri-mail-line",
    },
    {
      id: "cr-5",
      name: "Douglas County Clerk — Castle Rock",
      type: "County Clerk Passport Acceptance",
      address: "301 Wilcox St",
      city: "Castle Rock",
      state: "CO",
      zip: "80104",
      phone: "(303) 660-7446",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Douglas County Courthouse, downtown Castle Rock",
      website: "https://www.douglas.co.us/",
      websiteLabel: "Douglas County Clerk",
      notes: "County clerk passport acceptance with extended hours. Accepts walk-ins but appointments strongly recommended. Full-service county facility.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — I-25 north, 35 min (with traffic 1hr+)", fpc: "No — ship from Castle Rock" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "I-25 Rush Hour", agency: "The I-25 corridor is brutal 7–9 AM & 4–6 PM", fpc: "No driving — our courier handles timing" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Summer Vacation Season",
      description: "Douglas County families plan summer international travel heavily. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before your summer trip — Castle Rock facilities book out quickly.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Photos from big-box stores sometimes don't meet State Department standards. Must be exactly 2×2 inches on a white background — no smiles showing teeth for infants.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming Same-Day Walk-Ins Are Possible",
      description: "Even though Castle Rock is close to Denver, you cannot walk into the Colorado Passport Agency without a confirmed appointment. Appointments typically book 2–3 weeks out.",
    },
    {
      icon: "ri-car-line",
      title: "Underestimating I-25 Corridor Traffic",
      description: "Castle Rock's location means I-25 is the only route north to Denver. Rush hour (7–9 AM and 4–6 PM) can turn a 35-minute drive into an hour-plus. Our courier service eliminates this risk entirely.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Child Passport Requirements",
      description: "Both parents must appear for a child's passport or provide notarized consent. Many Castle Rock families schedule appointments only to discover one parent can't attend — wasting weeks.",
    },
    {
      icon: "ri-global-line",
      title: "Not Planning Around School Breaks",
      description: "Douglas County School District breaks create peak demand. Spring break (March) and summer (June–August) are the busiest acceptance facility periods. Book 3+ weeks ahead during school breaks.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Douglas County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop at any UPS or FedEx in Castle Rock, Castle Pines, or Parker." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — catching photo issues and form errors before submission." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our courier submits to the Denver agency just 35 miles away — one of the fastest routes in Colorado." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Castle Rock address — trackable every step." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Castle Rock, CO?", a: "Fast Passport Center offers emergency passport processing in Castle Rock, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Colorado Passport Agency just 35 miles north — this is one of the fastest courier routes in Colorado. No I-25 rush hour traffic to deal with." },
    { q: "Can I just drive to the Colorado Passport Agency from Castle Rock?", a: "You can — but you need an appointment confirmed by the NPIC (National Passport Information Center), which typically books 2–3 weeks out. During rush hour, I-25 can turn the 35-minute drive into an hour-plus. Our courier service is faster, more convenient, and guarantees timing." },
    { q: "What airport do Castle Rock travelers use for international flights?", a: "Denver International Airport (DEN) is the primary airport for Castle Rock and Douglas County — approximately 50 miles north via I-25 and E-470 (about 50 minutes without traffic). DEN offers nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations." },
    { q: "Can you help with passports for Highlands Ranch, Parker, and Lone Tree residents?", a: "Absolutely. Fast Passport Center serves all of Douglas County including Highlands Ranch, Parker, Lone Tree, Castle Pines, Larkspur, Sedalia, Franktown, Roxborough, and Elizabeth. We also serve southern Arapahoe County communities like Centennial and Greenwood Village." },
    { q: "How much does an expedited passport cost in Castle Rock, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a personalized quote based on your timeline." },
    { q: "Where can I get passport photos in Castle Rock?", a: "King Soopers (100 Founders Pkwy), Walgreens (3740 E 5th St), and Walmart (4400 Front St) all offer passport photo services. UPS Store at 323 Metzler Dr and the FedEx Office in Lone Tree also provide photos. Must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Is the Castle Rock Post Office always busy?", a: "Castle Rock is one of Colorado's fastest-growing communities, and the post office can get very busy — especially during summer family travel season. The Meadows Post Office location (with 7:30 AM opening) is often the better option for passport acceptance appointments." },
    { q: "Does Fast Passport Center serve Douglas County families with multiple passports?", a: "Yes. Fast Passport Center handles family passport bundles regularly for Castle Rock and Douglas County families. We can process multiple applications simultaneously — adult renewals, first-time child passports, and everything in between. One coordinated shipment, one coordinated delivery." },
  ],
  photoLocations: [
    { name: "King Soopers — Founders", address: "100 Founders Pkwy, Castle Rock, CO 80104", hours: "Mon–Sun: 6AM–11PM", website: "https://www.kingsoopers.com/stores" },
    { name: "Walgreens — East 5th", address: "3740 E 5th St, Castle Rock, CO 80104", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "Walmart — Front Street", address: "4400 Front St, Castle Rock, CO 80104", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/store/finder" },
    { name: "UPS Store — Metzler", address: "323 Metzler Dr, Castle Rock, CO 80108", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://locations.theupsstore.com/co/castle-rock" },
    { name: "FedEx Office — Lone Tree", address: "8451 S Yosemite St, Lone Tree, CO 80124", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://local.fedex.com/en-us/co/lone-tree" },
    { name: "Safeway — Castle Rock", address: "880 S Perry St, Castle Rock, CO 80104", hours: "Mon–Sun: 5AM–11PM", website: "https://www.safeway.com/shop/stores" },
  ],
  dmvLocations: [
    { name: "DMV — Castle Rock (Douglas County)", address: "301 Wilcox St, Castle Rock, CO 80104", hours: "Mon–Fri: 8AM–5PM", note: "Full-service Douglas County DMV located in the county courthouse. REAL ID and driver's license renewals. Appointment strongly recommended.", featured: true },
    { name: "DMV — Lone Tree", address: "9350 Heritage Hills Cir, Lone Tree, CO 80124", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV serving northern Douglas County. REAL ID processing. Less crowded than Castle Rock location.", featured: false },
    { name: "DMV — Parker", address: "11990 Apache Dr, Parker, CO 80138", hours: "Mon–Fri: 8AM–5PM", note: "Serves Parker and eastern Douglas County. Online appointments available. REAL ID processing.", featured: false },
  ],
  airports: [
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "50 miles north of Castle Rock via I-25 and E-470",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport. Nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. 50–60 minute drive from Castle Rock in normal traffic.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: true,
    },
    {
      code: "COS",
      name: "Colorado Springs Airport",
      distance: "45 miles south of Castle Rock via I-25",
      address: "7770 Milton E. Proby Pkwy, Colorado Springs, CO 80916",
      note: "Regional airport with domestic connections to major hubs including DEN, DFW, ORD, ATL, and PHX. 40-minute drive from Castle Rock.",
      flightUrl: "https://www.coloradosprings.gov/airport",
      flightLabel: "COS Flight Info",
      featured: false,
    },
    {
      code: "APA",
      name: "Centennial Airport",
      distance: "20 miles north of Castle Rock via I-25",
      address: "7800 S Peoria St, Englewood, CO 80112",
      note: "General aviation and private jet airport — one of the busiest general aviation airports in the U.S. Not used for commercial passenger travel. Serves private aviation for Douglas County and south Denver metro.",
      flightUrl: "https://www.centennialairport.com/",
      flightLabel: "APA Info",
      featured: false,
    },
  ],
};